import { REGIONS } from "./site";
import { SERVICES } from "./services";

const slugify = (s) => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Suburbs where we've photographed jobs that aren't in the homepage REGIONS chips,
// plus a couple of landmark aliases used in project titles.
const EXTRA_SUBURBS = {
  "Northern Beaches": ["Whale Beach", "Newport", "Bilgola", "Bayview", "Church Point"],
  "North Shore": ["Kirribilli", "Thornleigh", "Tennyson Point", "East Ryde", "Ryde", "Gladesville", "Hunters Hill", "Lane Cove", "Cammeray", "Northbridge", "Castlecrag"],
  "Inner West": ["Strathfield", "Homebush", "Lilyfield", "Drummoyne", "Five Dock", "Concord", "Burwood", "Enmore", "Erskineville", "St Peters"],
  "Western Sydney": ["Lidcombe", "Silverwater", "Macarthur Square", "Granville", "Rhodes", "Olympic Park", "Ermington", "Rydalmere", "Chester Hill", "Oatlands"],
  "Southern Sydney": ["Mascot", "Botany", "Brighton-Le-Sands", "Sans Souci", "Oatley", "Como"],
  "Eastern Suburbs": ["Waverley", "Queens Park", "Little Bay", "Matraville", "Watsons Bay"],
  "Hills District": ["West Pennant Hills", "Carlingford", "North Rocks", "Annangrove", "Box Hill"],
  "Sydney CBD": ["Sydney CBD", "Millers Point", "Walsh Bay", "Zetland", "Waterloo", "Alexandria", "Rosebery"],
};

const BLURBS = {
  "Northern Beaches": "From Manly to Palm Beach, the Northern Beaches is salt air, ocean views and homes built to look at the water. Frameless glass balustrades and pool fencing are our bread and butter here - marine-grade 2205 stainless fixings, low iron glass that doesn't tint the view, and crane lifts for the oversized panels that steep beach blocks demand.",
  "North Shore": "Kirribilli to Hornsby, Chatswood to the Ryde peninsula - the North Shore is where we do our most detailed residential work: curved glass staircases, oversized shaped mirrors, bevelled feature mirrors and glass replacement in heritage and architect-designed homes.",
  "Inner West": "Leichhardt, Rozelle, Marrickville, Strathfield - terrace renovations, harbourfront terraces, gyms and shopfronts. Replacing timber and wrought-iron stair balustrades with frameless glass is one of our most requested Inner West jobs, along with high performance glass replacement in apartments.",
  "Eastern Suburbs": "Bondi to Coogee to Vaucluse - shop front re-glazing on the beach strips, frameless pool fencing and balustrades for coastal homes, and shower screens and mirrors for apartment renovations. Fast turnaround on emergency glass replacement across the East.",
  "Hills District": "Castle Hill, Kellyville, Glenhaven and surrounds - new builds and large family homes. Channel-base glass stair balustrades with no visible fixings, front door and bifold glass replacement, pool fencing and home gym mirrors.",
  "Western Sydney": "Parramatta to Penrith, Auburn to Campbelltown - commercial and retail work is strong out West: tinted facade glass replacement, shopping centre mirror replacement, barber and salon fit-outs, plus residential glass replacement and pool fencing.",
  "Southern Sydney": "Mascot to Cronulla, Kogarah to Sutherland - balustrade panel replacement, glass pool fencing, shower screens and emergency glass replacement for homes and units across the South and the Shire.",
  "Sydney CBD": "Apartments, offices, rooftops and retail across the city - rooftop glass balustrades, office partition and shopfront glass, and mirror installation for gyms and studios, scheduled around building access and trading hours.",
};

export const AREAS = REGIONS.map((r) => ({
  slug: slugify(r.name),
  name: r.name,
  suburbs: r.suburbs,
  matchSuburbs: [...r.suburbs, ...(EXTRA_SUBURBS[r.name] || [])],
  blurb: BLURBS[r.name],
}));

export const getAreaBySlug = (slug) => AREAS.find((a) => a.slug === slug);

const hasSuburb = (title, suburbs) => {
  const t = title.toLowerCase();
  return suburbs.some((s) => new RegExp(`(^|[^a-z])${s.toLowerCase()}($|[^a-z])`).test(t));
};

/** Every featured project whose title names a suburb in this area. */
export const getAreaProjects = (area) => {
  const seen = new Set();
  const out = [];
  SERVICES.forEach((service) => {
    (service.projects || []).forEach((project) => {
      if (!hasSuburb(project.title, area.matchSuburbs)) return;
      const ba = [].concat(project.beforeAfter || [])[0];
      const image = ba ? ba.after : project.photos[0]?.src;
      if (seen.has(image)) return; // Tennyson Point appears on two service pages
      seen.add(image);
      out.push({ service, project, image });
    });
  });
  return out;
};
